<div class="flex-container">
  <div class="row">
    <div class="flex-item" [innerHTML]="error" ></div>
  </div>
  </div>
